import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleSheet } from 'react-native'

interface ProductNameProps {
    children: string
}

const ProductName: FC<ProductNameProps> = ({ children }) => {
    return (
        <Typography.Heading variant="h3" numberOfLines={2} style={styles.productName}>
            {children}
        </Typography.Heading>
    )
}

const styles = StyleSheet.create({
    productName: {
        flexShrink: 0,
        alignSelf: 'center',
        marginTop: 32,
        marginBottom: 24,
    },
})

export default ProductName
